import { render, staticRenderFns } from "./fangan.vue?vue&type=template&id=09c05420&scoped=true&"
import script from "./fangan.vue?vue&type=script&lang=js&"
export * from "./fangan.vue?vue&type=script&lang=js&"
import style0 from "./fangan.vue?vue&type=style&index=0&id=09c05420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c05420",
  null
  
)

export default component.exports